/**
 * Begleiter - Einheiten, die ein Hero beschwoert (ab 08.10.2026).
 *
 * Bis zur gemeinsamen Lane gab es hier das ganze Defense System: vier
 * kaufbare Defender, Defense Points, einen Beacon und zwei Ausbaustufen. Das
 * ist ersatzlos entfallen (GAME_DESIGN Abschnitt 10) - die Verteidigung
 * besteht jetzt aus der eigenen Army.
 *
 * Uebrig bleibt genau EINE Einheit: das Schattenbild des Shade. Es war
 * technisch ein Defender und bleibt es der Sache nach auch - es erscheint,
 * kaempft und vergeht. Nur kaufen, ausbauen und bezahlen kann man es nicht.
 *
 * Warum dafuer ein eigener Einheitentyp bleibt und der Schatten nicht
 * einfach ein Creep wird (Produktentscheidung vom 08.10.2026): Creeps bringen
 * Regeln mit, die der Schatten nicht haben darf - sie geben dem Gegner
 * Kill-Gold, marschieren die Lane entlang und machen Anchorschaden. Jede
 * davon muesste einzeln ausgeschaltet werden, und eine vergessene schenkte
 * dem Gegner Gold fuer ein Ultimate.
 */

/** Welche Begleiter es gibt. Bisher genau einer. */
export type BegleiterId = 'shadow';

export interface BegleiterDefinition {
  id: BegleiterId;
  name: string;

  maxHp: number;
  damage: number;
  /** Angriffe pro Sekunde. */
  attackSpeed: number;
  moveSpeed: number;
  armor: number;
  magicResistance: number;
  /** Umkreis, in dem er einen Gegner wahrnimmt. */
  aggroRange: number;
  attackRange: number;
  /** Wie stark ein Creep diesen Begleiter als Ziel bevorzugt. */
  threat: number;
}

/**
 * Das Schattenbild des Shade (Ultimate "Shadow Rift").
 *
 * Es erscheint beim Hero, bleibt dort stehen und sucht sich von dort Ziele.
 * Wie lange es bleibt, sagt der Skill - nicht diese Datei.
 *
 * Alle Zahlen sind TUNING_PLACEHOLDER.
 */
export const SHADOW_BEGLEITER: BegleiterDefinition = {
  id: 'shadow',
  name: 'Shadow',
  maxHp: 420,
  damage: 38,
  attackSpeed: 1.4,
  moveSpeed: 17,
  armor: 0,
  magicResistance: 0,
  aggroRange: 12,
  attackRange: 3,
  threat: 1,
};

const BEGLEITER_BY_ID: ReadonlyMap<string, BegleiterDefinition> = new Map([
  [SHADOW_BEGLEITER.id, SHADOW_BEGLEITER],
]);

/** Liefert die Definition eines Begleiters oder undefined. */
export function getBegleiter(id: string): BegleiterDefinition | undefined {
  return BEGLEITER_BY_ID.get(id);
}
